var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreencheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44_33711)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47.8299,
    cy: 52.6719,
    r: 32.8125,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9998 0.171936C21.5318 0.171936 -0.000183105 21.7039 -0.000183105 48.1719C-0.000183105 74.6399 21.5318 96.1719 47.9998 96.1719C74.4678 96.1719 95.9998 74.6399 95.9998 48.1719C95.9998 21.7039 74.4678 0.171936 47.9998 0.171936ZM47.6358 61.8479C46.0878 63.3959 44.0518 64.1679 42.0078 64.1679C39.9638 64.1679 37.9078 63.3879 36.3438 61.8279L25.2158 51.0439L30.7878 45.2959L41.9598 56.1239L65.1958 33.3199L70.8118 39.0199L47.6358 61.8479Z",
    fill: "#41A702"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_33711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white",
    transform: "translate(0 0.171936)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreencheck);
export default __webpack_public_path__ + "static/media/greencheck.36db140228d4fa0f1f0c4d809abe5676.svg";
export { ForwardRef as ReactComponent };